
import React, { useEffect } from "react";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import SecurityIcon from "@material-ui/icons/Security";
import LockIcon from "@material-ui/icons/Lock";
import { RouteService } from "services/route.service";
import { getDashboardHtmlWithSessionShibboleth } from "store/dashboard/action";
import { Keycloaklogin, hideMissMatchDriverIdModal } from "store/login/action";
import { getBuyCheckCreditCradDetails } from "store/buyPermits/action";
import { resetLoading } from 'store/layout/action';
import MissMatchDriverIdModal from "components/Modals/profile/MissMatchDriverIdModal";
import MessageModal from "components/Modals/MessageModals";
import ErrorModal from "components/Modals/ErrorModal";

const useStyles = makeStyles({
  navLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "transparent linear-gradient(180deg, #1F4A98 0%, #10254C 100%) 0% 0% no-repeat padding-box",
    height: "28px",
    borderRadius: "8px",
    padding: "2px 15px",
    marginLeft: "5px",
  },
  securityContauner: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    paddingRight: "15px",
    gap: "10px",
  },
  flexCenter: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    background:
      "transparent linear-gradient(180deg, #1F4A98 0%, #10254C 100%) 0% 0% no-repeat padding-box",
    boxShadow: "2px 5px 6px #00000029",
    height: "28px",
    padding: "2px 8px",
    borderRadius: "10px",
    textDecoration: "none",
  },
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: "white",
    fontSize: "12px",
  },
  iconColor: {
    color: "white",
  },
  active: {
    background: "#dde9ff",
    boxShadow: "1px 0 1px 1px #ccc",
  },
});

const PreLoginNavigationBar = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const UserParams = useParams();

  const homeStore = useSelector((state) => state["homeState"]);
  const citationDetailState = useSelector((state) => state.citationDetailState);
  const shibboleth = useSelector((state) => state?.dashboardState?.shibbolethStatus);
  const isCitationEnabled = useSelector(
    (state) => state?.loginState?.citationEnabled
  );

  const StylingItem = props.StylingItem;
  const path = history.location.pathname;

  const getPyCitationYN = () => {
    let res = true;
    if (
      path === RouteService.citationPaymentStatus(homeStore.customerName) ||
      path ===
      RouteService.citationDetail(
        homeStore.customerName,
        citationDetailState?.id,
        citationDetailState?.vehicle?.licensePlate?.number
      ) ||
      path === RouteService.payCitation(homeStore.customerName) ||
      path === RouteService.payCitationForm(homeStore.customerName)
    ) {
      res = false;
    }
    return res;
  };

  const isOpenMissMatchDriverIdModal = useSelector(
    (state) => state.loginState.missMatchDriverId
  );

  useEffect(() => {
    dispatch(getDashboardHtmlWithSessionShibboleth(UserParams.customer))
    dispatch(getBuyCheckCreditCradDetails(UserParams.customer));
  }, []);

  const mainContainer = {
    width: "100%",
    height: "40px",
    display: "flex",
    justifyContent: "space-between",
  };

  const { keycloak } = useKeycloak();
  const userLogOutData = JSON.parse(localStorage.getItem('keycloakTokenSet'));

  useEffect(() => {
    if (userLogOutData?.name === "logout") {
      console.log('enter else');
    } else {
      if (keycloak && keycloak?.authenticated) {
        localStorage.setItem("keycloak", JSON.stringify(keycloak))
        dispatch(Keycloaklogin(UserParams.customer))
      }
    }
  }, [keycloak?.authenticated]);

  const clearStaleKeycloakLoginState = () => {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('kc-callback-')) {
        localStorage.removeItem(key);
      }
    });
  };

  const onClickLogin = (event) => {
    localStorage.removeItem('keycloakTokenSet');
    clearStaleKeycloakLoginState(); // clean up old login state

    if (shibboleth?.data?.buyerAuthentication === "Shibboleth") {
      event.preventDefault();
      history.push(RouteService.home(`${homeStore.customerName}`));
      dispatch(resetLoading());
      keycloak.login();
    }
  }

  const handlecloseMissMatchDriverModal  = () => {
    dispatch(hideMissMatchDriverIdModal());
    keycloak.logout({
      redirectUri: history.push(RouteService.home(`${homeStore.customerName}/`))
    });
  };

  return (
    <>
      <div
        style={{
          ...mainContainer,
          ["background"]: StylingItem && StylingItem.navigationBarColor,
        }}
      >
        <div className={classes.center}>
          <NavLink
            to={RouteService.home(homeStore.customerName)}
            className={classes.flexCenter}
            activeClassName={classes.navLink}
          >
            <HomeIcon className={classes.iconColor} />
            <div className={classes.center} tabindex="1" >
                  <div
                    className={classes.text}
                    style={{ paddingRight: "10px" }}
                     >
                    Home
                  </div>
                </div>
          </NavLink>
        </div>
        {isCitationEnabled?.citationsEnabled === true ? (
          <div className={classes.securityContauner}>
            {getPyCitationYN() && (
              <NavLink 
                to={RouteService.payCitation(homeStore.customerName)}
                className={classes.flexCenter}
              >
                <SecurityIcon className={classes.iconColor} />
                <div className={classes.center} tabindex="1" >
                  <div
                    className={classes.text}
                    style={{ paddingRight: "10px" }}
                  >
                    Manage Citation
                  </div>
                </div>
              </NavLink>
            )}
            {(props.isPrelogin) &&
              <NavLink
                onClick={onClickLogin}
                to={RouteService.login(homeStore.customerName)}
                className={classes.flexCenter}
              >
                <LockIcon className={classes.iconColor} />
                <div className={classes.text} style={{ paddingRight: "10px" }} tabindex="1" >
                  Login
                </div>
              </NavLink>
            }
          </div>
        ) : (
          <div className={classes.securityContauner}>
            <NavLink
              onClick={onClickLogin}
              to={RouteService.login(homeStore.customerName)}
              className={classes.flexCenter}
            >
              <LockIcon className={classes.iconColor} />
              <div className={classes.text} style={{ paddingRight: "10px" }} tabindex="1" >
                Login
              </div>
            </NavLink>
          </div>
        )}
      </div>
      <MessageModal />
      <ErrorModal />
      <MissMatchDriverIdModal
        isOpenMissMatchDriverIdModal={isOpenMissMatchDriverIdModal}
        handlecloseMissMatchDriverModal={handlecloseMissMatchDriverModal}
      />
    </>
  );
};
export default PreLoginNavigationBar;